<!--  -->
<template>
  <div class="Banner">
    <swiper
      :auto-update="true"
      class="maf-swiper"
      ref="mySwiper"
      :options="swiperOption"
    >
      <swiper-slide
        class="swiper-slide"
        v-for="(item, index) in BannerList"
        :key="index"
      >
        <img :src="item.Banner" />
      </swiper-slide>
    </swiper>
    <div class="swiper-button-prev" slot="button-prev" @click="prev">
      <img src="../assets/banner/left.png" />
    </div>
    <div class="swiper-button-next" slot="button-next" @click="next">
      <img src="../assets/banner/right.png" />
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    //这里存放数据
    return {
      BannerList: [
      ],
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  //   props: {
  //     BannerList: {
  //       type: Array, // 定义接收到的数据的类型
  //       required: false, //规定这个数据是否必传,默认false
  //     },
  //   },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    prev() {
      this.$refs.mySwiper.$swiper.slidePrev();
    },
    next() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {

      var that = this;
      $.ajax({
                  url: "/index.php?s=Home/Api/get_data",
                  type: "get",
                  datatype: "json",
                  data: {
                    act: "ad_list",
                    pos_id: "1"
                  },
                  success: function (ret) {
                    var obj = JSON.parse(ret); //json数据转为数组
                    if (obj.code == "0000") {
                       if(obj.data){
                           $.each(obj.data,function(i,k){
                                                  var guanggao = {
                                                      Banner: k.pos_picture,
                                                  };
                                                  that.BannerList.push(guanggao);
                           })
                       }
                    }
                  },
                  error: function (err) {
                    console.log("ajax错误");
                  },
      });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../scss/public.scss";
.Banner {
  width: 100%;
  height: 40rem;
  .maf-swiper {
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    top: 60%;
  }
  .swiper-button-next {
    right: 40px;
  }
  .swiper-button-next::after {
    content: none;
  }
  .swiper-button-prev {
    left: 40px;
  }
  .swiper-button-prev::after {
    content: none;
  }
}
@media screen and (max-width: 1200px) {
  .Banner {
    width: 100%;
    height: 100%;
    .swiper-button-prev,
    .swiper-button-next {
      top: 60%;
      display: none;
    }
    .swiper-button-next {
      right: 40px;
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Banner.vue